import React, { useEffect } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { Link as RouterLink, useParams, useNavigate, useLocation } from 'react-router-dom';
import { BackArrowIcon } from '../../icons';
import UniversityDetails from '../../components/HomeTabs/UniversityDetails';
import { useSelector, useDispatch } from 'react-redux';
import { setFields, resetFields } from './reducer/universityFormSlice';
import { fetchUniversity } from '../../api/universityApi';

const UniversityListingManagement = ({ backUrl = '/university-listing-management' }) => {
  const fields = useSelector(state => state.universityForm.fields);
  const userAuth = useSelector(state=>state?.auth)
  const dispatch = useDispatch();
  const { universityId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const resolvedBackUrl = location.state?.backUrl || backUrl;
  const isReviewer = userAuth?.user?.roles.some(ele=>ele?.module==="reviewer" && ele?.allowed===1)


  const handleBack = (e) => {
    e.preventDefault();
    if (resolvedBackUrl === -1) {
      navigate(-1);
    } else if (typeof resolvedBackUrl === 'string') {
      navigate(resolvedBackUrl,{state:{backUrl:location?.pathname,activeTab:location?.state?.activeTab}});
    } else {
      navigate(-1);
    }
  };
  
  const loadUniversity = async (id = universityId) => {
    try {
      const updatedFields = await fetchUniversity(id, fields,isReviewer);
      if (updatedFields) dispatch(setFields(updatedFields));
    } catch (err) {
      dispatch(resetFields());
      console.error('Error fetching university:', err);
    }
  };

  useEffect(() => {
    if (universityId) loadUniversity();
    else dispatch(resetFields());
  }, [universityId, dispatch]);

  return (
    <Box sx={{ background: '#fff' }}>
      <div
        className="page-header"
        style={{
          position: 'sticky',
          top: '4.5rem',
          zIndex: '9',
          padding: '10px 15px',
          borderBottom: '1px solid #E6E7E8',
          background: '#fff',
        }}
      >
        <div className="row align-items-center">
          <div className="col">
            <Typography
              sx={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#15243E',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <IconButton onClick={handleBack} size="small" aria-label="Back">
                <BackArrowIcon />
              </IconButton>
                University CRM Entry Form
            </Typography>
          </div>
          <div className="col">
            <Box display="flex" gap={2} sx={{ justifyContent: 'end' }}>
              {/* <Button sx={{ border: '1px solid #15243E', minHeight: 'auto', p: '4px 15px', color: '#15243E', background: '#fff', fontSize: '14px', textTransform: 'capitalize' }}>
                Preview
              </Button>
              <Button sx={{ border: '1px solid #1075FF', minHeight: 'auto', p: '4px 15px', color: '#1075FF', background: '#fff', fontSize: '14px', textTransform: 'capitalize' }}>
                Save Draft
              </Button>
              <Button sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', p: '4px 15px', fontSize: '14px', textTransform: 'capitalize' }}>
                Publish
              </Button> */}
            </Box>
          </div>
        </div>
      </div>

      <UniversityDetails
        fields={fields}
        setFields={updatedFields => dispatch(setFields(updatedFields))}
        fetchUniversity={loadUniversity}
        editMode={isReviewer}
      />
    </Box>
  );
};

export default UniversityListingManagement;
